import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Icon } from 'antd'

import { categories } from '@services/api'

@inject((store: any) => {
    const { popupStore, categoriesStore } = store

    return { popupStore, categoriesStore }
})
@observer
export default class MoveCategoryPopup extends Component<any, any> {
    moveCategory = async () => {
        if (this.props.categoriesStore.editing) {
            const { dragFrom, dragTo } = this.props.popupStore.info
            await categories.updateCategory({ params: { parent_id: dragTo }, id: dragFrom })
            this.props.categoryMoved()
            this.props.popupStore.togglePopup(false)
        } else {
            this.closePopup()
        }
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const { popupType, info } = this.props.popupStore
        const { indexedCategories } = this.props.categoriesStore
        const message =
            indexedCategories[info.dragTo] && indexedCategories[info.dragFrom] ? (
                <div>
                    <div style={{ fontSize: '0.95rem' }}>
                        העברת קטגורית
                        <strong>
                            {indexedCategories[info.dragFrom].name} ({indexedCategories[info.dragFrom].id})
                        </strong>
                        <Icon type="arrow-left" /> תחת
                        <strong>
                            {indexedCategories[info.dragTo].name} ({indexedCategories[info.dragTo].id})
                        </strong>
                    </div>
                </div>
            ) : (
                ''
            )
        return (
            <Modal
                title="האם לבצע את ההעברה הבאה?"
                visible={popupType === 'moveCategory'}
                onOk={this.moveCategory}
                onCancel={this.closePopup}
                okText="העבר קטגוריה"
                cancelText="ביטול"
            >
                {message}
            </Modal>
        )
    }
}
